/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiKey } from 'model/apiKeys';

export interface ApiKeysState {
    status: ApiKeysStatus;
    loading: boolean;
    error?: string;
    /**
     * Last key created, updated or rotated, without its secret.
     * The secret never enters the store: the thunks return it to the caller.
     */
    savedApiKey?: ApiKey;
    apiKeys: Array<ApiKey>;
}

export enum ApiKeysStatus {
    // eslint-disable-next-line no-unused-vars
    Initial,
    // eslint-disable-next-line no-unused-vars
    Error,
    // eslint-disable-next-line no-unused-vars
    Fetching,
    // eslint-disable-next-line no-unused-vars
    FetchSuccess,
    // eslint-disable-next-line no-unused-vars
    Saving,
    // eslint-disable-next-line no-unused-vars
    SaveSuccess,
    // eslint-disable-next-line no-unused-vars
    Rotating,
    // eslint-disable-next-line no-unused-vars
    RotateSuccess,
    // eslint-disable-next-line no-unused-vars
    Revoking,
    // eslint-disable-next-line no-unused-vars
    RevokeSuccess
}
